import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaHeadset, 
  FaClock, 
  FaEnvelope, 
  FaPhoneAlt, 
  FaVideo,
  FaComments,
  FaArrowLeft,
  FaWhatsapp,
  FaCheckCircle,
  FaCalendarAlt,
  FaUserGraduate,
  FaFileAlt,
  FaGlobe,
  FaStar,
  FaQuoteLeft,
  FaHeart,
  FaTrophy,
  FaShieldAlt,
  FaRocket,
  FaUserFriends,
  FaBook,
  FaMobileAlt,
  FaEuroSign,
  FaChartLine,
  FaMedal,
  FaGift,
  FaUsers,
  FaHandshake,
  FaBriefcase,
  FaHome,
  FaPassport,
  FaChalkboardTeacher,
  FaChevronRight
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './SupportContinu.css';

const SupportContinu = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const services = [
    {
      id: 1,
      title: "Support administratif",
      description: "Aide pour toutes vos démarches administratives : CAF, sécurité sociale, titre de séjour, assurance maladie",
      icon: <FaFileAlt />,
      hours: "Lun-Ven, 9h-18h",
      featured: true
    },
    {
      id: 2,
      title: "Assistance académique",
      description: "Suivi de votre parcours scolaire, aide aux inscriptions, choix de filière et réorientation",
      icon: <FaUserGraduate />,
      hours: "Lun-Ven, 10h-17h",
      featured: false
    },
    {
      id: 3,
      title: "Support personnel",
      description: "Écoute et accompagnement pour les difficultés personnelles, bien-être et adaptation en France",
      icon: <FaComments />,
      hours: "7j/7, 24h/24",
      featured: true
    },
    {
      id: 4,
      title: "Aide linguistique",
      description: "Cours de français, soutien linguistique personnalisé et préparation aux examens DELF/DALF",
      icon: <FaGlobe />,
      hours: "Lun-Sam, 14h-20h",
      featured: false
    },
    {
      id: 5,
      title: "Support technique",
      description: "Assistance pour les outils numériques, plateformes d'apprentissage et visioconférences",
      icon: <FaMobileAlt />,
      hours: "Lun-Ven, 8h-20h",
      featured: false
    },
    {
      id: 6,
      title: "Aide à l'insertion",
      description: "Conseils pour l'intégration sociale, culturelle et professionnelle en France",
      icon: <FaUserFriends />,
      hours: "Sur rendez-vous",
      featured: false
    }
  ];

  const packages = [
    {
      name: "Étude de Dossier",
      price: "50€",
      priceValue: 50,
      description: "Analyse complète de votre dossier académique",
      stripeLink: "https://buy.stripe.com/bJe8wPh1rgOidB12El3wQ00",
      features: [
        "Analyse détaillée du dossier scolaire",
        "Évaluation des chances d'admission",
        "Conseils personnalisés",
        "Feedback sur votre CV",
        "Recommandations d'amélioration",
        "Délai de réponse : 72h"
      ],
      recommended: false,
      popular: false,
      icon: <FaFileAlt />
    },
    {
      name: "Offre Standard",
      price: "100€",
      priceValue: 100,
      description: "Accompagnement complet pour votre orientation",
      stripeLink: "https://buy.stripe.com/6oU00j7qRfKegNdceV3wQ02",
      features: [
        "Tout de l'offre Étude de Dossier",
        "Accompagnement personnalisé",
        "Aide à la rédaction de lettres de motivation",
        "Préparation aux entretiens",
        "Suivi hebdomadaire",
        "Accès aux webinaires exclusifs"
      ],
      recommended: true,
      popular: true,
      icon: <FaChartLine />
    },
    {
      name: "Offre Premium",
      price: "500€",
      priceValue: 500,
      description: "Accompagnement VIP vers la réussite",
      stripeLink: "https://buy.stripe.com/bJecN5fXn8hMcwX5Qx3wQ01",
      features: [
        "Tout de l'offre Standard",
        "Accompagnement illimité",
        "Simulations d'entretiens",
        "Aide à la recherche de logement",
        "Assistance pour les démarches visa",
        "Support prioritaire 7j/7",
        "Coaching individuel",
        "Garantie satisfaction"
      ],
      recommended: false,
      popular: false,
      icon: <FaMedal />
    }
  ];

  const customOffer = {
    name: "Offre Personnalisée",
    description: "Vous pouvez librement choisir le montant de votre contribution sur Stripe",
    stripeLink: "https://buy.stripe.com/fZufZhfXnapUbsT92J3wQ03",
    features: [
      "Soutenez notre mission éducative",
      "Contribution à votre convenance",
      "Accompagnement adapté à vos besoins",
      "Contact personnalisé avec notre équipe",
      "Suivi dédié selon votre investissement",
      "Possibilité de payer en plusieurs fois"
    ],
    icon: <FaGift />
  };

  const channels = [
    { name: "Téléphone", icon: <FaPhoneAlt />, hours: "9h-20h (5j/7)", color: "#1069D3", availability: "Rapide" },
    { name: "Email", icon: <FaEnvelope />, hours: "Réponse sous 24h", color: "#DC143C", availability: "Écrit" },
    { name: "Visio", icon: <FaVideo />, hours: "Sur rendez-vous", color: "#1E3C72", availability: "Personnalisé" },
    { name: "WhatsApp", icon: <FaWhatsapp />, hours: "9h-22h (7j/7)", color: "#25D366", availability: "Immédiat" },
    { name: "Chat en ligne", icon: <FaComments />, hours: "Lun-Ven, 10h-18h", color: "#9b59b6", availability: "Direct" },
    { name: "Live chat", icon: <FaHeadset />, hours: "Sur réservation", color: "#e67e22", availability: "Gratuit" }
  ];

  const benefits = [
    { icon: <FaUserFriends />, title: "Suivi personnalisé", desc: "Accompagnement adapté à votre profil" },
    { icon: <FaClock />, title: "Réponse garantie sous 24h", desc: "Rapidité et efficacité" },
    { icon: <FaGlobe />, title: "Support multilingue", desc: "Français, anglais, arabe, espagnol" },
    { icon: <FaFileAlt />, title: "Accompagnement administratif", desc: "Toutes les démarches simplifiées" },
    { icon: <FaBook />, title: "Veille académique", desc: "Informations et actualités" },
    { icon: <FaUserGraduate />, title: "Réseau d'experts", desc: "Mentors et professionnels" }
  ];

  const testimonials = [
    {
      name: "Laura M.",
      country: "Canada",
      text: "L'offre Standard m'a permis d'obtenir tous les conseils nécessaires pour réussir mon orientation. Je recommande vivement !",
      rating: 5,
      service: "Offre Standard"
    },
    {
      name: "Mohamed A.",
      country: "Maroc",
      text: "L'étude de dossier m'a aidé à identifier mes points forts et à améliorer ma candidature. Un service professionnel et efficace.",
      rating: 5,
      service: "Étude de Dossier"
    },
    {
      name: "Sophie L.",
      country: "Côte d'Ivoire",
      text: "L'offre Premium m'a accompagnée de A à Z dans toutes mes démarches. Le coaching individuel m'a vraiment aidé à réussir.",
      rating: 5,
      service: "Offre Premium"
    }
  ];

  const faqs = [
    {
      q: "Comment se déroule l'étude de dossier ?",
      a: "Après votre inscription, nous analysons en détail votre dossier scolaire, nous évaluons vos chances d'admission et vous fournissons un rapport complet avec des conseils personnalisés sous 72h."
    },
    {
      q: "Quelle est la différence entre les offres ?",
      a: "L'offre Étude de Dossier est une analyse ponctuelle de votre dossier. L'offre Standard inclut un accompagnement complet sur la durée. L'offre Premium ajoute un coaching illimité, une assistance visa et logement, ainsi qu'un support prioritaire 7j/7."
    },
    {
      q: "Puis-je payer l'offre personnalisée en plusieurs fois ?",
      a: "Oui, sur Stripe vous avez la possibilité de choisir le montant et de payer en plusieurs fois selon vos besoins. Contactez-nous pour plus d'informations."
    },
    {
      q: "Les offres incluent-elles l'aide au logement ?",
      a: "L'offre Premium inclut une aide complète à la recherche de logement. Pour les autres offres, nous pouvons vous orienter vers nos partenaires."
    },
    {
      q: "Proposez-vous un remboursement ?",
      a: "Nous offrons une garantie satisfaction sur l'offre Premium. Pour les autres offres, nous nous engageons à fournir un service de qualité et restons à votre écoute."
    },
    {
      q: "Comment se passe le suivi hebdomadaire ?",
      a: "Le suivi se fait par visioconférence, téléphone ou WhatsApp selon votre préférence. Nous faisons le point sur vos avancées et ajustons les conseils si nécessaire."
    }
  ];

  const stats = [
    { value: "500+", label: "Étudiants accompagnés", desc: "Depuis notre lancement" },
    { value: "24h", label: "Délai de réponse", desc: "Support prioritaire" },
    { value: "98%", label: "Satisfaction", desc: "Clients satisfaits" },
    { value: "100%", label: "Accompagnement", desc: "Personnalisé" }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="support-service-page">
      <Header />
      
      {/* Hero Section with Animated Background */}
      <section className="support-hero">
        <div className="support-hero-bg">
          <div className="support-hero-bg-gradient"></div>
          <div className="support-hero-bg-particles"></div>
        </div>
        <div className="support-hero-container">
          <div className="support-hero-content">
            <div className="support-badge">
              <FaHeart /> Accompagnement personnalisé
            </div>
            <h1>Support <span className="support-gradient-text">Continu</span></h1>
            <p>Un accompagnement personnalisé et disponible à chaque étape de votre parcours en France. Nous sommes là pour vous, 7j/7.</p>
            <div className="support-hero-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="support-stat-item">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                    <small>{stat.desc}</small>
                  </div>
                  {index < stats.length - 1 && <div className="support-stat-divider"></div>}
                </React.Fragment>
              ))}
            </div>
            <div className="support-hero-buttons">
              <Link to="#packages" className="support-btn-primary">Découvrir nos offres</Link>
              {/* <Link to="/contact" className="support-btn-outline">Contacter un conseiller</Link> */}
              <a href="https://wa.me/33695744027" className="support-btn-whatsapp-hero">
                <FaWhatsapp /> Démarrer une conversation
              </a>
            </div>
          </div>
        </div>
        <div className="support-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Services Section */}
      <section className="support-services">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Nos services d'accompagnement</h2>
            <p>Un support complet pour toutes vos préoccupations, disponible 7j/7</p>
          </div>
          <div className="support-services-grid">
            {services.map((service) => (
              <div key={service.id} className={`support-service-card ${service.featured ? 'featured' : ''}`}>
                {service.featured && (
                  <div className="support-service-badge">
                    <FaStar /> Service prioritaire
                  </div>
                )}
                <div className="support-service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="support-service-hours">
                  <FaClock /> {service.hours}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section id="packages" className="support-packages">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Nos formules d'accompagnement</h2>
            <p>Choisissez l'offre qui correspond le mieux à vos besoins</p>
          </div>
          <div className="support-packages-grid">
            {packages.map((pkg, index) => (
              <div key={index} className={`support-package-card ${pkg.recommended ? 'recommended' : ''}`}>
                {pkg.popular && (
                  <div className="support-package-popular">
                    <FaStar /> Le plus populaire
                  </div>
                )}
                <div className="support-package-icon" style={{ background: `linear-gradient(135deg, var(--stats-primary), var(--stats-secondary))` }}>
                  {pkg.icon}
                </div>
                <h3>{pkg.name}</h3>
                <div className="support-package-price">
                  <FaEuroSign /> {pkg.price}
                </div>
                <p className="support-package-description">{pkg.description}</p>
                <ul className="support-package-features">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx}>
                      <FaCheckCircle /> {feature}
                    </li>
                  ))}
                </ul>
                <a 
                  href={pkg.stripeLink} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="support-package-btn"
                >
                  Payer {pkg.price} <FaChevronRight />
                </a>
              </div>
            ))}
          </div>

          {/* Offre Personnalisée */}
          <div className="support-custom-offer">
            <div className="support-custom-card">
              <div className="support-custom-icon">{customOffer.icon}</div>
              <h3>{customOffer.name}</h3>
              <p>{customOffer.description}</p>
              <ul className="support-custom-features">
                {customOffer.features.map((feature, idx) => (
                  <li key={idx}>
                    <FaCheckCircle /> {feature}
                  </li>
                ))}
              </ul>
              <a 
                href={customOffer.stripeLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="support-custom-btn"
              >
                Choisir mon montant sur Stripe <FaChevronRight />
              </a>
            </div>
          </div>

          <div className="support-packages-note">
            <p>* Tous nos forfaits sont sans engagement. Paiement sécurisé via Stripe.</p>
          </div>
        </div>
      </section>

      {/* Channels Section */}
      <section className="support-channels">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Plusieurs façons de nous contacter</h2>
            <p>Choisissez le canal qui vous convient le mieux</p>
          </div>
          <div className="support-channels-grid">
            {channels.map((channel, index) => (
              <div key={index} className="support-channel-card" style={{ borderTopColor: channel.color }}>
                <div className="support-channel-icon" style={{ color: channel.color }}>
                  {channel.icon}
                </div>
                <h3>{channel.name}</h3>
                <p>{channel.hours}</p>
                <span className="support-channel-availability">{channel.availability}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="support-benefits">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Pourquoi choisir notre support ?</h2>
            <p>Un engagement fort pour votre réussite en France</p>
          </div>
          <div className="support-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="support-benefit-item">
                <div className="support-benefit-icon">{benefit.icon}</div>
                <div className="support-benefit-content">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="support-testimonials">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Ils nous font confiance</h2>
            <p>Découvrez les retours de nos étudiants accompagnés</p>
          </div>
          <div className="support-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="support-testimonial-card">
                <FaQuoteLeft className="support-quote-icon" />
                <p className="support-testimonial-text">"{testimonial.text}"</p>
                <div className="support-testimonial-author">
                  <div>
                    <strong>{testimonial.name}</strong>
                    <div className="support-testimonial-info">
                      <span>{testimonial.country}</span>
                      <span className="dot">•</span>
                      <span>{testimonial.service}</span>
                    </div>
                  </div>
                  <div className="support-testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="support-faq">
        <div className="support-container">
          <div className="support-section-header">
            <h2>Questions fréquentes</h2>
            <p>Tout ce que vous devez savoir sur nos services</p>
          </div>
          <div className="support-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="support-faq-item">
                <button className="support-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`support-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`support-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="support-cta">
        <div className="support-container">
          <div className="support-cta-wrapper">
            <div className="support-cta-content">
              <h2>Besoin d'aide ? Nous sommes là pour vous</h2>
              <p>Profitez d'un premier conseil gratuit avec notre équipe de support. Sans engagement.</p>
              <div className="support-cta-buttons">
                <Link to="/contact" className="support-btn-dark">Prendre rendez-vous</Link>
                <a href="https://wa.me/33695744027" className="support-btn-whatsapp">
                  <FaWhatsapp /> Démarrer une conversation
                </a>
              </div>
              <div className="support-cta-note">
                <FaRocket /> Premier échange offert, réponse garantie sous 24h
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SupportContinu;